var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},_vm._l((_vm.pageTitle),function(item,index){return _c('div',{key:index,staticClass:"item",on:{"click":() => _vm.toPage(item.url)}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }